import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen } from '@fortawesome/pro-solid-svg-icons';

import {
    UNBLOCK_USER_SUCCESS
} from '../../messages/messageActions'

import blockedUsersEN from './locales/BlockedUsers_en.json';
import blockedUsersFR from './locales/BlockedUsers_fr.json';

import './BlockedUsers.less';

class BlockedUsers extends React.Component {
    constructor(props) {
        super(props);

        i18next.addResourceBundle('en', 'BlockedUsers', blockedUsersEN);
        i18next.addResourceBundle('fr', 'BlockedUsers', blockedUsersFR);
    }

    render() {
        const { t, blockedUsers } = this.props;

        if(!blockedUsers || blockedUsers.length < 1) {
            return (<h2>{t('No blocked users')}</h2>)
        }

        return (
            <div className="BlockedUsers">
                <div className="BlockedUsers__Content">
                    <h2>{t('Blocked Users')}</h2>
                    <div className="BlockedUsers__List">
                        {blockedUsers.map((u) => {
                            return (<div className='blocked-user'>
                                <b className="user-name">{u.name}</b>
                                <button className="ant-btn ant-btn-primary unblock-button" onClick={() => {this.unblock(u.id)}}><FontAwesomeIcon icon={faLockOpen}/></button>
                            </div>)
                        })}
                    </div>                    
                </div>
            </div>
        )
    }

    unblock(id) {
        if (confirm(this.props.t('Confirm Unblock'))) {
                this.props.unblockUser(id).then((e) => {
                if (e.type === UNBLOCK_USER_SUCCESS) {
                    this.props.fetchBlockedUsers();
                }
            })
        }
    }
}

export default translate('BlockedUsers')(BlockedUsers);